export enum ChatEntityType {
    General = 1,
    Order = 2,
    Product = 3
}
